import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BrightsideUiModule } from 'libs/brightside-ui/src/lib/brightside-ui.module';
import { routePath } from 'libs/desktop/data-access/core-services/src/lib/Routing/routing.functions';
import { NewSpendingAccountService, SpendingAccount } from '../../../new-spending-account.service';
import { Subject, takeUntil, tap } from 'rxjs';

@Component({
    selector: 'brightside-web-cash-advance-money-help-card',
    imports: [BrightsideUiModule, TranslateModule],
    templateUrl: './cash-advance-money-help-card.component.html',
    styleUrl: './cash-advance-money-help-card.component.scss'
})
export class CashAdvanceMoneyHelpCardComponent {
  data: { route: string | undefined };
  currentAccountInfo: SpendingAccount | undefined;

  private _router = inject(Router);

  cellClick() {
    if (this.data?.route) {
      this._router.navigate([routePath(this.data?.route)]);
    } else {
      this._router.navigate([routePath('cash_advance_info_view')]);
    }
  }
}
